export {
    type OcrFormValues,
    type OcrProduct,
    type OcrPayment,
    type OcrTaxLine,
    isPaymentPartiallyFilled,
} from 'composables/ocr/ocrFormSchema';

export interface SupplierOption {
    value: number;
    label: string;
}

export interface SupplierAction {
    label: string;
    callback: () => void;
}

export enum OcrFormType {
    INVOICE = 'purInvoice',
    CREDIT_NOTE = 'purCreditNote',
}

export enum OcrFormStep {
    DRAFT = 'draft',
    DUE = 'due',
    STORED = 'stored',
}

export enum OcrLineMode {
    PRODUCT = 'product',
    TAX = 'tax',
}

export interface OcrPreview {
    mime: string | null;
    url: string | null;
}

export interface OcrQueueRow {
    id: number | string;
}

export interface OcrTypeOption {
    label: string;
    value: OcrFormType;
    enabled: boolean;
}

export interface OcrStepOption {
    label: string;
    value: OcrFormStep;
    color: string;
}

export type AnalyticsMode = 'doc' | 'item' | null;

export interface AjaxAutocompleteParams {
    q: string;
    types: string[];
}
